//import tags
import { Link } from 'react-router-dom';

//import resources
import Logo from '../../assets/images/logo.svg'

//import components
import Search from '../dynamic/header/Search';
import Nav from '../dynamic/header/Nav';
import Auth from '../dynamic/header/Auth';
import CartDropdown from '../dynamic/header/CartDropdown';

export default function Header({locale}) {
    return (
        <>
            <header className='border-t-2 border-[var(--orange)] py-5 px-3'>
                <div className='container mx-auto'>
                    <div className='grid grid-cols-12 gap-4'>
                        <div className='col-span-6 lg:col-span-3'>
                            <Link to={`/${locale}`} className='h-full flex items-center'>
                                <img src={Logo} alt='Celestron.ge' />
                            </Link>
                        </div>
                        <div className='col-span-6 hidden lg:block'>
                            <Search />
                        </div>
                        <div className='col-span-6 lg:col-span-3'>
                            <div className='flex justify-end'>
                                <Auth />
                                <CartDropdown />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <Nav locale={locale} />
        </>
    );
}